/**
 * Product page image framing.
 * Menu cards stay square (object-cover). The product page defaults to the
 * original photo (object-contain) so tall/wide cakes are not cropped.
 * Tammy can switch a photo back to fill-square via image display settings.
 */

export type DetailFit = 'contain' | 'cover';

/** Invalid or missing values become contain (original photo). */
export function normalizeDetailFit(value: unknown): DetailFit {
  return value === 'cover' ? 'cover' : 'contain';
}

/** Outer frame: square crop box vs flexible original-size box. */
export function productDetailImageFrameClass(fit: DetailFit): string {
  if (fit === 'cover') {
    return 'md:w-1/2 aspect-square relative overflow-hidden bg-gray-100';
  }
  return 'md:w-1/2 relative overflow-hidden bg-gray-100 flex items-center justify-center min-h-[16rem]';
}

/** Img classes: fill-square crop vs show the whole uploaded file. */
export function productDetailImageClass(fit: DetailFit): string {
  if (fit === 'cover') {
    return 'w-full h-full object-cover transition-transform duration-300 hover:scale-105';
  }
  return 'w-full h-auto max-h-[70vh] object-contain';
}
